export default __webpack_public_path__ + "static/media/logo-vbee.fc951572.svg";